function fetchJSON(url, callback) {
    fetch(url, { cache: 'no-store' })  // 'no-store' to prevent caching
        .then(response => {
            if (!response.ok) {
                throw new Error('Network response was not ok ' + response.statusText);
            }
            return response.text();
        })
        .then(data => callback(null, data))
        .catch(error => callback(error, null));
}

fetchJSON('https://www.tileamerica.com/cache/header_cached_html.html', function(error, header_html) {
    if (error) {
        console.error(error);
    } else {
        header_html = header_html.replace(/src="\//g, 'src="https://www.tileamerica.com/')
                         .replace(/href="\//g, 'href="https://www.tileamerica.com/');
        document.body.insertAdjacentHTML('afterbegin', header_html);

        do_algolia_search();
        do_primary_nav_handling();
    }
});

fetchJSON('https://www.tileamerica.com/cache/footer_cached_html.html', function(error, footer_html) {
    if (error) {
        console.error(error);
    } else {
       $('#MainContent').after(footer_html);
       $('#footer img').each(function() {
         if($(this).attr('src')) {
           var src = $(this).attr('src');
           if(src.indexOf('/') == 0) {
             src = 'https://www.tileamerica.com'+src;
             $(this).attr('src',src);
           }
         }
       });
       $('#footer a').each(function() {
         var href = $(this).attr('href');
         if(href.indexOf('/') == 0) {
           href = 'https://www.tileamerica.com'+href;
           $(this).attr('href',src);
         }
       });
    }
});


/* ----------------------------------------------------------------------------------------------------------------------- */
/* Mobile Check Element -------------------------------------------------------------------------------------------------- */
/* ----------------------------------------------------------------------------------------------------------------------- */
$('body').append('<div id="mobile-check-element"></div>');


/* ----------------------------------------------------------------------------------------------------------------------- */
/* Site Search (Algolia) ------------------------------------------------------------------------------------------------- */
/* ----------------------------------------------------------------------------------------------------------------------- */
function do_algolia_search() {
  const algolia_application_id = 'R6SCRB5JFO';
  const algolia_search_only_api_key = 'f53cae2a8ce0277fbd1fa9005ccf85af';
  const searchClient = algoliasearch(algolia_application_id, algolia_search_only_api_key);
  const search = instantsearch({
      indexName: 'sscms_content',
      searchClient,
  });

  let seenProducts = new Set();
  
  search.addWidgets([
    instantsearch.widgets.configure({
        hitsPerPage: 100
    }),
    
    instantsearch.widgets.searchBox({
          container: '#custom-tileamerica-algolia-search-box',
          searchOnEnterKeyPressOnly: true,
          placeholder: "Search...",
          queryHook: function (query, search) {
              const hitsContainer = document.getElementById('custom-tileamerica-algolia-search-results-wrap');
              hitsContainer.style.display = query.trim() !== '' ? 'flex' : 'none';
              search(query);
          },
      }),
  
      instantsearch.widgets.hits({
          container: '#custom-tileamerica-algolia-pages-search-results',
          templates: {
              item: (hit, { html, components }) => {
                if(hit.url.indexOf('/') == 0) {
                    hit.url = 'https://www.tileamerica.com'+hit.url;
                }
                
                return html`
                    <a href="${hit.url}">${components.Highlight({ hit, attribute: "title" })}</a>          
                `;
                // ${components.Highlight({ hit, attribute: "content" })}
              }
          },
      }),
  
      instantsearch.widgets
        .index({ indexName: 'shopify_products' })
        .addWidgets([
            instantsearch.widgets.hits({
            container: '#custom-tileamerica-algolia-other-search-results',

            transformItems(items) {
                const seen = new Set();
                const results = [];

                items.forEach(hit => {
                const handle = hit.handle;

                // Inject parent product once per handle
                if (!seen.has(handle)) {
                    seen.add(handle);

                    results.push({
                    ...hit,
                    _isParentProduct: true,
                    objectID: `parent_${handle}` // ensure unique
                    });
                }

                // Always push the variant hit
                results.push({
                    ...hit,
                    _isParentProduct: false
                });
                });

                return results;
            },

            templates: {
                item(hit, { html, components }) {

                if (hit._isParentProduct) {
                    const img =
                    hit.product_image ||
                    'https://www.tileamerica.com/images/template/product-image-placeholder.webp';

                    return html`
                    <a href="https://shop.tileamerica.com/products/${hit.handle}?view=custom"
                        class="product-search-item collection-item">
                        <img src="${img}" alt="" />
                        <span class="title-wrap">
                        ${hit.title} Collection
                        </span>
                    </a>
                    `;
                }

                const variantImg =
                    hit.image ||
                    'https://www.tileamerica.com/images/template/product-image-placeholder.webp';

                return html`
                    <a href="https://tileamerica.myshopify.com/products/${hit.handle}?variant=${hit.objectID}"
                    class="product-search-item">
                    <img src="${variantImg}" alt="" />
                    <span class="title-wrap">
                        ${components.Highlight({ hit, attribute: 'title' })}
                        <span class="variant-title">${hit.variant_title}</span>
                    </span>
                    </a>
                `;
                }
            }
            })

            // Add pagination if you have many results
            /*
            instantsearch.widgets.pagination({
                container: '#custom-tileamerica-algolia-pagination',
            })
            */
        ])
   ]);
  
  search.start();

  $(document).on('keydown','.ais-SearchBox-input',function(e) {
    if(e.keyCode == 13 && $(this).val()) {
        window.location.href = 'https://shop.tileamerica.com/search/?q='+$(this).val();
    }
  });
  
  $(document).on('click','#see-all-results-button',function() {
      window.location.href = 'https://shop.tileamerica.com/search/?q='+$('.ais-SearchBox-input').val();
      return false;
  });

  if($('.ais-page .ais-SearchBox-input').length) {
    $('.ais-page .ais-SearchBox-input').attr('placeholder','Search color, shape, size, etc...');
  }
}


/* ----------------------------------------------------------------------------------- */
/* Shopify Algolia plugin: capture parent data + inject Collection card via sanitize  */
/* ----------------------------------------------------------------------------------- */
window.__tileamericaCollectionData = window.__tileamericaCollectionData || new Map();

(function () {
    function registerCollectionHook() {
        if (typeof algoliaShopify === 'undefined' || !algoliaShopify.hooks) {
            return setTimeout(registerCollectionHook, 50);
        }

        algoliaShopify.hooks.registerHook(
            'beforeInstantSearchProductTemplate',
            function (template, hit) {
                if (hit && hit.handle && !window.__tileamericaCollectionData.has(hit.handle)) {
                    window.__tileamericaCollectionData.set(hit.handle, {
                        handle: hit.handle,
                        title: hit.title,
                        product_image: hit.product_image,
                        image: hit.image
                    });
                }
                // Pass the template through completely unchanged.
                return template;
            }
        );
    }
    registerCollectionHook();
})();


(function ($) {
    const processedTitleClass = 'custom-title-processed';
    const processedPriceClass = 'custom-price-processed';

    function cleanTitle(title) {
        return (title || '').replace(/[()/]/g, '').trim();
    }

    function buildCollectionCard(data) {
        const img =
            data.product_image ||
            data.image ||
            'https://www.tileamerica.com/images/template/product-image-placeholder.webp';
        const title = cleanTitle(data.title);

        return (
            '<li class="ais-Hits-item collection-item"><a href="/products/' + data.handle + '?view=custom" ' +
               'class="ais-hit ais-product collection-card-injected product-search-item collection-item" ' +
               'data-handle="' + data.handle + '">' +
                '<div class="ais-hit--picture">' +
                    '<img src="' + img + '" alt="" />' +
                '</div>' +
                '<div class="ais-hit--details">' +
                    '<div class="ais-hit--title">' +
                        '<span class="title-wrap">' + title + ' Collection</span>' +
                    '</div>' +
                '</div>' +
            '</a></li>'
        );
    }

    function pruneStaleCollections() {
        $('li.collection-item').each(function () {
            const $li = $(this);
            const handle = $li.find('.collection-card-injected').data('handle');

            // Find the next variant hit that follows this Collection card.
            const $nextVariant = $li
                .next('li.ais-Hits-item')
                .find('.ais-hit.ais-product')
                .not('.collection-card-injected')
                .first();
            const nextHandle = $nextVariant.data('handle');

            if (!handle || !nextHandle || nextHandle !== handle) {
                $li.remove();
            }
        });
    }

    function sanitizeHits() {
        // Drop any Collection cards that no longer sit in front of their variant.
        pruneStaleCollections();

        // Track handles that already have a Collection card in the DOM.
        const injectedHandles = new Set();
        $('.collection-card-injected').each(function () {
            injectedHandles.add($(this).data('handle'));
        });

        $('.ais-hit.ais-product').not('.collection-card-injected').each(function () {
            const $hit = $(this);
            const handle = $hit.data('handle');

            // --- sanitize title ---
            const $titleLink = $hit.find('.ais-hit--title a');
            if ($titleLink.length && !$titleLink.hasClass(processedTitleClass)) {
                $titleLink.text(cleanTitle($titleLink.text()));
                $titleLink.addClass(processedTitleClass);
            }

            // --- sanitize price ---
            const $priceWrapper = $hit.find('.ais-hit--price');
            if ($priceWrapper.length && !$priceWrapper.hasClass(processedPriceClass)) {
                const $b = $priceWrapper.find('b');
                if ($b.text().trim() === '$0.00') {
                    $b.text('Call for Pricing');
                    $priceWrapper.addClass('call-for-pricing');
                }
                $priceWrapper.addClass(processedPriceClass);
            }
            if ($priceWrapper.find('.ais-hit--price-striked').length &&
                $priceWrapper.find('.ais-hit--price-striked').text().trim() !== '') {
                $priceWrapper.addClass('has-discount');
            }

            // --- inject Collection card before first variant of this handle ---
            if (handle && !injectedHandles.has(handle)) {
                injectedHandles.add(handle);
                const data = window.__tileamericaCollectionData &&
                            window.__tileamericaCollectionData.get(handle);
                if (data) {
                    const $li = $hit.closest('li.ais-Hits-item');
                    ($li.length ? $li : $hit).before(buildCollectionCard(data));
                }
            }
        });

        // --- handle stats cloning (unchanged) ---
        $('.ais-Stats-text').each(function () {
            const new_val = $(this).text();
            if ($(this).attr('data-text') !== new_val) {
                $(this).attr('data-text', new_val);
                if (!$(this).closest('.ais-Stats').next('.ais-Stats.cloned').length) {
                    $(this).closest('.ais-Stats').after('<div class="ais-Stats cloned"></div>');
                }
                const new_html = new_val.replace(/results found.*$/, '').trim();
                $(this).closest('.ais-Stats').next('.ais-Stats.cloned').html(new_html);
            }
        });
    }

    function waitForHits() {
        sanitizeHits();
        setTimeout(waitForHits, 100);
    }

    $(document).ready(function () {
        waitForHits();
    });
})(jQuery);


/* ----------------------------------------------------------------------------------------------------------------------- */
/* Primary Nav Handling -------------------------------------------------------------------------------------------------- */
/* ----------------------------------------------------------------------------------------------------------------------- */
function do_primary_nav_handling() {
  // remove target=_blank from "Products" sub menu
  if($('.nav-link-products').length) {
    $('.nav-link-products').addClass('selected');
    $('.nav-link-products a').attr('target','');
  }

  // move cart
  /*
  $('#cart-icon').attr('class','');
  $('#quick-links li').last().html('').append($('#cart-icon'));
  */
  
  $('.nav-toggle').click(function() {
    $('body').toggleClass('show-nav');
    return false;
  });
  
  $(document).keydown(function(e) {
      if(e.keyCode == 27 && $('body').hasClass('show-nav')) {
          $('body').removeClass('show-nav');
      }
  });
  
  $('#primary-nav-wrap li.sub > a').click(function() {
      if($('#mobile-check-element').css('display') == 'block') {
          if(!$(this).hasClass('clicked')) {
              $(this).addClass('clicked');
              $(this).next('ul').slideDown('fast');
              return false;
          }
      }
  });
  
  // Large Format Mobile Nav Handling
  var nav_delay_timeout_length = 150;
  var nav_delay_timeout;
  var secondary_nav_delay_timeout;
  $('#primary-nav-wrap > ul > li').mouseenter(function () {
      if($('#mobile-check-element').css('display') == 'none') {
          if(!$(this).hasClass('hovered')) {
              var item = $(this);
              clearTimeout(nav_delay_timeout);
              nav_delay_timeout = setTimeout(function () {
                  $('#primary-nav-wrap > ul > li.hovered').removeClass('hovered');
                  item.addClass('hovered');
              }, nav_delay_timeout_length);
          }
      }
  });
  $('#primary-nav-wrap > ul > li').mouseleave(function () {
      if($('#mobile-check-element').css('display') == 'none') {
          clearTimeout(nav_delay_timeout);
      }
  });
  $('#header-top,#MainContent').mouseenter(function() {
      if($('#mobile-check-element').css('display') == 'none') {
          clearTimeout(nav_delay_timeout);
          nav_delay_timeout = setTimeout(function () {
              $('#primary-nav-wrap > ul > li.hovered').removeClass('hovered');
          }, nav_delay_timeout_length);
      }
  });
  
  var nav_toggle_icon = `
      <svg xmlns="http://www.w3.org/2000/svg" width="9" height="9" viewBox="0 0 9 9" class="toggle">
          <g id="nav-plus" transform="translate(-1715 -176)">
              <rect id="Rectangle_196" data-name="Rectangle 196" width="1" height="9" transform="translate(1719 176)" fill="#1c1b1a"/>
              <rect id="Rectangle_197" data-name="Rectangle 197" width="1" height="9" transform="translate(1715 181) rotate(-90)" fill="#1c1b1a"/>
          </g>
      </svg>
  `;
  $('#primary-nav-wrap li.sub > a').append(nav_toggle_icon);

  function do_primary_nav_column_wrapping() {
      $('#primary-nav-wrap > ul > li.sub').each(function() {
          if(!$(this).find('ul.level-2').length && $('#mobile-check-element').css('display') == 'none') {
              if(!($(this).find('.column-wrap').length)) {
                  var parentli = $(this);
                  $(parentli).addClass('no-third-level');
                  var $lis = $(parentli).find('> ul > li');
                  var count = $lis.length;
                  var items_per_column = Math.ceil(count / 3);
                  for(i=0;i<3;i++) {
                      var $newCol = $('<div class="column"></div>');
                      $lis.slice(i * items_per_column, (i + 1) * items_per_column).appendTo($newCol);
                      $(parentli).find('>ul').append($newCol);
                  }
                  $(parentli).find('>ul').wrapInner('<div class="column-wrap"></div>');
              }
          }
      });
  }
    
  $('#primary-nav-wrap > ul > li > ul > li').mouseenter(function () {
      if($('#mobile-check-element').css('display') == 'none') {
          if(!$(this).hasClass('hovered')) {
              var item = $(this);
              clearTimeout(nav_delay_timeout);
              nav_delay_timeout = setTimeout(function () {
                  $('#primary-nav-wrap > ul > li.selected > ul > li.sub').removeClass('selected');
                  $('#primary-nav-wrap > ul > li.hovered > ul > li.sub').removeClass('hovered');
                  $(item).addClass('hovered');
              }, nav_delay_timeout_length);
          }
      }
  });
  $('#primary-nav-wrap > ul > li.sub > ul > li.sub').mouseleave(function () {
      if($('#mobile-check-element').css('display') == 'none') {
          clearTimeout(nav_delay_timeout);
      }
  });

  // adjust quick links dropdown handling
  if($('#quick-links').length) {
      $('#quick-links > ul > li').each(function() {
          if($(this).find('ul').length) {
              $(this).addClass('sub');
              $(this).find('>a').append(nav_toggle_icon);
          }
      });
  }
  
  // reworking html structure
  var nav_mode = 'desktop';
  do_primary_nav_column_wrapping();
  $(window).resize(function() {
      if($('#mobile-check-element').css('display') != 'none') {
          if(nav_mode == 'desktop') {
              nav_mode = 'mobile';
              $('#header').after($('#primary-nav-wrap'));
              if($('#quick-links').length) $('#primary-nav-wrap').prepend($('#quick-links'));
              if($('#site-search-wrap').length) $('#primary-nav-wrap').prepend($('#site-search-wrap'));
              if($('#primary-nav-wrap .column').length) {
                  $('#primary-nav-wrap .column').unwrap();
                  $('#primary-nav-wrap .level-1 .column li').unwrap();
              }
          }
  
      } else {
          if(nav_mode == 'mobile') {
              nav_mode = 'desktop';
              $('#header-main').append($('#primary-nav-wrap'));
              if($('#site-search-wrap').length) $('#header-top').append($('#site-search-wrap'));
              if($('#quick-links').length) $('#header-top').append($('#quick-links'));
              do_primary_nav_column_wrapping();
          }
      }
  }).resize();
  
  // mobile specific handling
  $('#quick-links li.sub > a, #primary-nav-wrap li.sub > a').click(function() {
      if($('#mobile-check-element').css('display') != 'none') {
          if(!$(this).closest('li').hasClass('clicked')) {
              $(this).closest('li').addClass('clicked');
              $(this).next('ul').slideDown('fast');
              return false;
          }
      }
  });
}


/* ----------------------------------------------------------------------------------------------------------------------- */
/* Custom Section -> Custom Products Carousel ---------------------------------------------------------------------------- */
/* ----------------------------------------------------------------------------------------------------------------------- */



/* ----------------------------------------------------------------------------------------------------------------------- */
/* Custom Section -> Custom Collection Carousel -------------------------------------------------------------------------- */
/* ----------------------------------------------------------------------------------------------------------------------- */
$(document).ready(function() {
  if($('.ta-custom-slider-stage').length) {
    $('.ta-custom-slider-stage').each(function() {
      var stage = $(this);
    
      var slick_slider_obj = [];
      slick_slider_obj.container = $(stage);
      $(stage).slick({
          arrows: true,
          autoplay : false,
          dots: false,
          infinite: true,
          slide : ".slide",
          slidesToShow: 3,
          speed : 500,
          responsive: [
              {
                  breakpoint: 1024,
                  settings: {
                      slidesToShow: 2
                  }
              },
              {
                  breakpoint: 500,
                  settings: {
                      slidesToShow: 1
                  }
              },
          ]
      });
    });
    
    $(document).on('click','.ta-custom-slider-stage .slide',function() {
        window.location.href = $(this).find('a').attr('href');
        return false;
    });
  }
});


/* ----------------------------------------------------------------------------------------------------------------------- */
/* Custom Section -> Installation Images Carousel (Product Detail Page) -------------------------------------------------- */
/* ----------------------------------------------------------------------------------------------------------------------- */
$(document).ready(function() {
  if($('.installation-images-slideshow').length) {    
    function getSelectedVariantParts($form) {
        var parts = [];

        $form.find('.main-product__form-option input:checked').each(function() {
            parts.push($(this).val().toLowerCase());
        });

        return parts;
    }

    function slideMatchesVariant(rule, selectedParts) {
        var ruleParts = rule.split('/').map(function(p){
            return p.trim().toLowerCase();
        });

        // rule cannot be longer than selected variant
        if (ruleParts.length > selectedParts.length) {
            return false;
        }

        for (var i = 0; i < ruleParts.length; i++) {
            if (ruleParts[i] !== selectedParts[i]) {
                return false;
            }
        }

        return true;
    }

    function getMatchScore(rule, selectedParts) {
        var ruleParts = rule.split('/').map(function(p){
            return p.trim().toLowerCase();
        });

        if (ruleParts.length > selectedParts.length) {
            return 0;
        }

        for (var i = 0; i < ruleParts.length; i++) {
            if (ruleParts[i] !== selectedParts[i]) {
                return 0;
            }
        }

        return ruleParts.length; // specificity score
    }

    $('.installation-images-slideshow').each(function() {
        var slider = $(this);

        slider.slick({
            arrows: true,
            autoplay: false,
            dots: true,
            infinite: true,
            fade: true,
            slide: ".slide",
            slidesToShow: 1,
            speed: 1000,
            responsive: [{
                breakpoint: 500,
                settings: {
                    fade: false,
                    speed: 750
                }
            }]
        });

        if($('.main-product__selector').length) {
            var $form = $('.main-product__selector');
            var selectedParts = getSelectedVariantParts($form);

            if(selectedParts.length) {

                var bestIndex = -1;
                var bestScore = 0;

                slider.find('.slide').each(function(index) {

                    var variantData = ($(this).data('variants') || '').toLowerCase();
                    if(!variantData) return;

                    var rules = variantData.split(',');

                    for(var i = 0; i < rules.length; i++) {
                        var rule = rules[i].trim();
                        var score = getMatchScore(rule, selectedParts);

                        if(score > bestScore) {
                            bestScore = score;
                            bestIndex = index;
                        }
                    }
                });

                if(bestIndex !== -1) {
                    slider.slick('slickGoTo', bestIndex);
                }
            }
        }

        $(this).prepend('<a href="#" class="do-installation-image-zoom-button">Zoom</a>');
        $('.do-installation-image-zoom-button').click(function() {
            $('body').toggleClass('installation-zoom-mode');
            $('.slick-initialized').each(function() {
                var $slider = $(this);
                if ($slider.hasClass('slick-initialized')) {
                    $slider.slick('setPosition');
                }
            });
            return false;
        });
    });
  }
});




/* ----------------------------------------------------------------------------------------------------------------------- */
/* Custom Landing Pages (e.g. https://shop.tileamerica.com/products/tile-pavers-aextra20-while-supplies-last?view=custom)  */
/* ----------------------------------------------------------------------------------------------------------------------- */
$(document).ready(function() {
    if(
        ($('body').hasClass('template--custom') && $('.variant-item').length) ||
        ($('body').hasClass('template--product') && $('.product-variant-image-anchor').length)
    ) {
        var slides_html = '';
        var idx = 0;

        if($('body').hasClass('template--custom') && $('.variant-item').length) {
            $('.variant-item').each(function() {
                slides_html += '<div class="slide">'+$(this).find('a').html()+'</div>';
                $(this).prepend('<a href="#" class="do-tile-zoom-button" data-index="'+idx+'">Zoom</a>');
                idx++;
            });

        } else {
            $('.product-variant-image-anchor').each(function() {
                slides_html += '<div class="slide">'+$(this).html()+'</div>';
                $(this).prepend('<a href="#" class="do-tile-zoom-button" data-index="'+idx+'">Zoom</a>');
                idx++;
            });
        }

        if(slides_html) {
            $('body').append(
                '<a href="#" class="close-tile-images-fullscreen-slider" id="close-tile-images-fullscreen-slider">Close</a>' +
                '<div class="tile-images-fullscreen-slider" id="tile-images-fullscreen-slider">'+slides_html+'</div>'
            );

            if($('body').hasClass('template--custom') && $('.variant-item').length) {
                $('#tile-images-fullscreen-slider img').each(function() {
                    $(this).attr('src',$(this).attr('src').replace('&width=400','&width=1600'));
                });
            } else {
                $('#tile-images-fullscreen-slider .caption').each(function() {
                    $(this).addClass('variant-name');
                });
            }
                
            var slider = $('#tile-images-fullscreen-slider');

            slider.slick({
                arrows: true,
                autoplay: false,
                dots: true,
                infinite: true,
                fade: true,
                slide: ".slide",
                slidesToShow: 1,
                speed: 1000,
                responsive: [{
                    breakpoint: 500,
                    settings: {
                        fade: false,
                        speed: 750
                    }
                }]
            });

            $('#close-tile-images-fullscreen-slider').click(function() {
                $('body').removeClass('view-tile-zoom-mode');
                return false;
            });

            $('.do-tile-zoom-button').click(function() {
                var index = parseInt($(this).data('index'), 10);

                $('body').addClass('view-tile-zoom-mode');
                slider.slick('slickGoTo', index, true);
                slider.slick('setPosition');

                return false;
            });

            // ESC key closes
            $(document).on('keyup', function(e) {
                if (e.key === 'Escape') {
                    $('body').removeClass('view-tile-zoom-mode');
                }
            });
        }
    }
});


/* ----------------------------------------------------------------------------------------------------------------------- */
/* Arrow Links ----------------------------------------------------------------------------------------------------------- */
/* ----------------------------------------------------------------------------------------------------------------------- */
$(document).ready(function() {
  var arrow_svg = `
  <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="14" height="11.99" viewBox="0 0 14 11.99">
    <defs>
      <clipPath id="clip-path">
        <rect id="Rectangle_244" data-name="Rectangle 244" width="14" height="11.99" fill="#1c1b1a"/>
      </clipPath>
    </defs>
    <g id="black-arrow-right" clip-path="url(#clip-path)">
      <path id="Path_207" data-name="Path 207" d="M14,6.02a.632.632,0,0,1-.186.449L8.455,11.828a.637.637,0,0,1-.89-.04.637.637,0,0,1,0-.867l4.264-4.264H.637a.636.636,0,1,1,0-1.273H11.828L7.556,1.111A.637.637,0,1,1,8.414.17l5.4,5.4A.632.632,0,0,1,14,6.02" transform="translate(0 0)" fill="#1c1b1a" fill-rule="evenodd"/>
    </g>
  </svg>
  `;
  $('.arrow-link').each(function() {
      $(this).append(arrow_svg);
  });
});


/* ----------------------------------------------------------------------------------------------------------------------- */
/* Product Listing Customizations ---------------------------------------------------------------------------------------- */
/* ----------------------------------------------------------------------------------------------------------------------- */
$(document).ready(function() {
  if($('#FacetFiltersForm').length && $('#ProductGridContainer').length) {
    document.body.addEventListener('products-grid-loaded', function() {
      do_ta_custom_facets_display();
    });

    do_ta_custom_facets_display();

    function do_ta_custom_facets_display() {
      if($('#cloned-ta-facets-display').length) $('#cloned-ta-facets-display').remove();
      $('#ProductGridContainer').prepend('<div id="cloned-ta-facets-display" class="cloned-ta-facets-display"><div id="cloned-ta-facets-top"></div><div id="cloned-ta-facets-bottom"></div></div>');

      $('#cloned-ta-facets-top').html('<div class="ta-count">'+$('#FacetFiltersForm .product-count').html()+'</div><div class="ta-sort">'+$('#FacetFiltersForm .facet-filters.sorting').html()+'</div>');
      if($('#FacetFiltersForm .active-facets-desktop .active-facets__button').length) $('#cloned-ta-facets-bottom').html('<div class="active-facets-desktop">'+$('#FacetFiltersForm .active-facets-desktop').html()+'</div>');
    }
  }

  if($('.main-product__media').length) { 
    jQuery('.product-media__modal-image').each(function() {
      if(jQuery(this).find('.caption').length) {
        jQuery(this).addClass('has-caption'); 
      }
    });
    
    // tmp fix for gallery display issue
    setTimeout(function() { window.dispatchEvent(new Event('resize')); },1000);
    setTimeout(function() { window.dispatchEvent(new Event('resize')); },2000);
    setTimeout(function() { window.dispatchEvent(new Event('resize')); },3000);
    setTimeout(function() { window.dispatchEvent(new Event('resize')); },4000);
    setTimeout(function() { window.dispatchEvent(new Event('resize')); },5000);    
  }

  $(document).on('click','.main-product__media-item',function(e) {
    window.location.href = $(this).find('a').attr('href');
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    return false;
  });

  $(document).on('click','.product-variant-image-anchor',function(e) {
    window.location.href = $(this).attr('href');
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    return false;
  });
});


/* ----------------------------------------------------------------------------------------------------------------------- */
/* Mobile Page Heading Text Fitment -------------------------------------------------------------------------------------- */
/* ----------------------------------------------------------------------------------------------------------------------- */
$.getScript("https://cdn.jsdelivr.net/npm/fitty/dist/fitty.min.js")
    .done(function () {
        jQuery(".container.custom-product-detail-page h1").each(function () {
            var $heading = jQuery(this);
            var maxSize = parseFloat($heading.css("font-size"));
            var words = $heading.text().trim().split(/\s+/);

            $heading.empty();

            jQuery.each(words, function (index, word) {
                if (index > 0) {
                    $heading.append(document.createTextNode(" "));
                }

                $heading.append(
                    jQuery("<span>", {
                        class: "fit-word",
                        text: word
                    })
                );
            });

            $heading.find(".fit-word").each(function () {
                fitty(this, {
                    minSize: 10,
                    maxSize: maxSize,
                    multiLine: false
                });
            });
        });
    })
    .fail(function () {
        console.error("Failed to load Fitty.");
    });